export default "__VITE_ASSET__22f08e80__"